import React from 'react';
import { Button, Col, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../FieldGroup.jsx';
import GroupRole from './GroupRole.jsx';
import './FileForm.module.css';

const FileForm = (props) => {
  const {
    submitError,
    submitFailed,
    submitting,
    selectedGroups,
    errors,
    handleSubmit,
  } = props;

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={8}>
            <Field
              id="name"
              name="name"
              label="Title"
              type="text"
              placeholder="Enter here"
              component={FieldGroup}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={8}>
            <Field
              id="url"
              name="url"
              label="URL"
              type="text"
              placeholder="https://"
              component={FieldGroup}
            />
          </Col>
        </Row>

        <GroupRole
          selectedGroups={selectedGroups}
          errors={errors}
          submitFailed={submitFailed}
        />

        <Row className="m-b-20">
          <Col xs={8}>
            {submitFailed && (
              <FormGroup validationState="error">
                <HelpBlock>
                  {submitError || 'Please fill in all required fields'}
                </HelpBlock>
              </FormGroup>
            )}
          </Col>
          <Col xs={12}>
            <div className="flex flex-justify">
              <div>
                <Button bsStyle="default" onClick={() => window.history.back()}>
                  <a className="text-muted" href="#">
                    Cancel
                  </a>
                </Button>

                <Button
                  className="m-l-12"
                  bsStyle="primary"
                  disabled={submitting}
                  type="submit"
                >
                  {submitting ? 'Saving...' : 'Save'}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </form>
    </React.Fragment>
  );
};

export default FileForm;
